export const EXPERIMENT_NUMBER = {
  EXPERIMENT_1: 'experiment1',
  EXPERIMENT_2: 'experiment2'
};

export const SELECTOR_TYPE = {
  STANDARD: 'standard',
  OUTLINED: 'outlined'
};
